import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType, PostsSortOrder } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

const mapStateToProps = (
  state: AppState,
  ownProps: { sortOrder: PostsSortOrder }
) => {
  const draftsStreamId = getPostsDeviationsStreamId({
    type: PostsType.DRAFTS,
    sortOrder: ownProps.sortOrder,
  });
  const drafts = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, draftsStreamId)
  );

  return {
    streamId: draftsStreamId,
    items: drafts,
    hasMore: streamSelectors.hasMore(state, draftsStreamId),
    isFetching: streamSelectors.isFetching(state, draftsStreamId),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const draftsStreamId = getPostsDeviationsStreamId({
    type: PostsType.DRAFTS,
    sortOrder: ownProps.sortOrder,
  });
  return {
    fetchMore: () => dispatch(withOffset.actions.fetch(draftsStreamId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
